import { getApi, postApi, ErrorResponse } from './baseApi';
import { AUTH_ENDPOINTS } from '../constants/endpoints';

// Without two-factor: {token, otp_required: false, otp_token: null}.
// With two-factor on: {token: null, otp_required: true, otp_token} -> send the code to verifyLoginApi.
export interface OwnerLoginResponse {
  token: string | null;
  otp_required?: boolean;
  otp_token?: string | null;
}

export const loginApi = (data: { email: string; password: string }): Promise<OwnerLoginResponse | ErrorResponse> =>
  postApi(AUTH_ENDPOINTS.LOGIN, data);

// code: the app's 6 digits, or a backup code like 7KQ4-M2XD. The otp_token lasts 5 minutes.
export const verifyLoginApi = (data: { otp_token: string; code: string }): Promise<{ token: string } | ErrorResponse> =>
  postApi(AUTH_ENDPOINTS.LOGIN_VERIFY, data);

// 204: ends every owner token on every device
export const logoutApi = (): Promise<any | ErrorResponse> => postApi(AUTH_ENDPOINTS.LOGOUT);

export const getMeApi = (): Promise<any | ErrorResponse> =>
  getApi(AUTH_ENDPOINTS.ME);
